import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    isMenuOpen: true,
    searchButton: 'mostPopular',
  },
  reducers: {
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
    changeSearchButton: (state, action) =>{
      state.searchButton = action.payload;
    } 
  },
});

export const { toggleMenu, closeMenu,changeSearchButton } = appSlice.actions;
export default appSlice.reducer;
